import { userConstants } from "../../constant";
export function allUsers(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_USERS:
      return action.users;
    default:
      return state;
  }
}
